import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface IProps {
  show: boolean;
  text?: string;
  onClickOverlay?: () => void;
}

const VLoading = (props: IProps) => {
  const { show, text, onClickOverlay } = props;
  const { t } = useTranslation();
  return (
    <LoadingWrapper>
      {show && (
        <>
          <div className="overlay" onClick={onClickOverlay}></div>
          <div className="container">
            <div className="loading">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div className="text">{text || t('common.loading')}</div>
          </div>
        </>
      )}
    </LoadingWrapper>
  );
};

export default VLoading;

const LoadingWrapper = styled.div`
  .overlay {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  .container {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 9999;
    width: 124px;
    min-height: 124px;
    padding: 15px;
    border-radius: 8px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .text {
      text-align: center;
    }
  }
  .loading {
    width: 80px;
    height: 80px;
    margin: 0 auto;
  }
  .loading div {
    position: absolute;
    width: 56px;
    height: 56px;
    margin: 12px;
    border: 6px solid #30b043;
    border-radius: 50%;
    animation: loading 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #30b043 transparent transparent transparent;
  }
  .loading div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .loading div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .loading div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes loading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
